import { TCompleteUser } from "apis/auth/auth";
import { TUser } from "apis/user";
import { WorkSpace } from "apis/workspace/getWorkspaceInfo";
import { atom } from "recoil";
import { TMember, TWorkspace } from "types/user.types";

export const userRole = atom({
  key: "userRole",
  default: {
    role: parseInt(`${localStorage.getItem("role")}`),
  },
});

export const userInfo = atom<{ user: TUser | null; workspace: WorkSpace | null }>({
  key: "userInfo1",
  default: {
    user: null,
    workspace: null,
  },
});

export const util = atom<{ language: "ko" | "en" }>({
  key: "util",
  default: {
    language: "ko",
  },
});

//UPDATE: (new) user 정보에 대한 recoilState 추가
export const workspace = atom<TWorkspace | undefined>({
  key: "workspaceInfo",
  default: undefined,
});

export const user = atom<TCompleteUser | undefined>({
  key: "userInfo",
  default: undefined,
});

export const member = atom<TMember | undefined>({
  key: "memberInfo",
  default: undefined,
});

export const complainManager = atom<boolean | undefined>({
  key: "complainManager",
  default: undefined,
});
